import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewImage = _resolveComponent("PreviewImage")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    title: _ctx.$t('screenWatermark.previewTitle'),
    "model-value": _ctx.modelValue,
    width: "1000px",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_PreviewImage, { wmdata: _ctx.wmdata }, null, 8, ["wmdata"])
    ]),
    _: 1
  }, 8, ["title", "model-value", "onClose"]))
}